import Api from '@/services/Api'

const URL = 'cat/lista-precio-producto/';
const ACCION_AGREGAR_TIENDA = 'agregar_tienda';
const ACCION_ELIMINAR_TIENDA = 'eliminar_tienda';


export default {
    
    fetch(params) {
        return Api().get(URL,{
            params: params
        })
    },
    getById(id) {
        return Api().get(URL + id)
    },
    save(params) {
        let url = URL;
        if ('id' in params) {
            return Api().put(url + params.id + '/', params)
        }
        return Api().post(url, params)
    },
    agregar_tienda(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACCION_AGREGAR_TIENDA}/`, params);

    },
    eliminar_tienda(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACCION_ELIMINAR_TIENDA}/`, params);

    },
}